import React from 'react';

import styled from '@emotion/styled';
import { NavTabs } from 'react-magma-dom';
import { COLORS } from '../../constants';

export const StyledNavTabs = styled(({ ...rest }) => <NavTabs {...rest} />)<{
  isSecondary: boolean;
  isSideNav: boolean;
  isVertical: boolean;
}>`
  a {
    color: ${({ isSecondary }) => (isSecondary ? COLORS.white : null)}!important;

    :hover {
      color: ${({ isSecondary }) => (isSecondary ? COLORS.white : null)}!important;
    }

    :focus {
      outline: ${({ isSecondary }) => (isSecondary ? COLORS.white : COLORS.blueCola)} dotted 2px !important;
      color: ${({ isSecondary }) => (isSecondary ? COLORS.white : COLORS.seaBlue)}!important;
    }
  }

  li {
    max-width: 300px !important;

    ${({ isSideNav }) =>
      isSideNav &&
      `
        width: auto!important;
        margin-bottom: 14px!important;
        
        ::after {
          top: unset!important;
          left: 16px!important;
          width: calc(100% - 32px)!important;
          height: 4px!important;
        }
        
        a {
          color: ${COLORS.neutral3}!important;
        }
      `};

    ::after {
      @media (hover: none) {
        margin: 5px auto !important;
      }
      margin: 5px !important;
      background: ${({ isSecondary }) => (isSecondary ? COLORS.white : null)}!important;
    }
  }

  div {
    height: 100% !important;
  }

  nav {
    height: 50% !important;
  }

  ul {
    height: 100% !important;

    ${({ isSideNav }) =>
      isSideNav &&
      `
        justify-content: flex-start!important;
        align-items: flex-start!important;
        padding-top: 63px!important;
      `};
    ${({ isVertical }) =>
      isVertical &&
      `
      height: 100px!important;
    `};
  }
`;
